import React from 'react';

export default function ToolbarDivider() {
  return (
    <span className="self-center w-1 h-8 mx-2 border-l border-common-dark" />
  );
}
